import * as React from "react";
const SvgMaze = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", fill: "none", stroke: "currentColor", strokeWidth: 6, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8,8h48v48h-48z m36,0v12h-15 m-9,-3v15h27 m-15,0v24 m-24,-12h15m18,0h15" }));
export default SvgMaze;
